exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".reviews-section-wrapper .pa-2.v-card{border:0}", ""]);

// exports
